import React from 'react'
import {Box,Button,Paper,ButtonGroup,Tooltip, Typography} from '@mui/material'
import {
  TextFields,
  Notes,
  RadioButtonChecked,
  CheckBox,
  ArrowDropDownCircle,
  PlaylistAddCheck,
  ToggleOn,
    UploadFile,
    Star,
} from "@mui/icons-material";
import MainBlock from './smallcomponents/MainBlock';
import { useSurveyStore } from '../surveyutilities/surveyStore';
function EcxSurveyCanvas() {
  const currentState = useSurveyStore(s => s)
  const questions = useSurveyStore(state => state.questions);
  const addQuestion = useSurveyStore(state => state.addQuestion);

  //console.log("Questions : "+questions);
  const handleQuestionAdd = (questionType) =>{
   // console.log("Handle Questions Add : "+questionType);
    addQuestion(questionType);
  }
  return (
   <Box sx={{
        flex: 1,
        overflow: 'auto',
        minHeight: '90vh',
        backgroundColor:'#e0e0e0',
        borderRadius:'10px',
        p:'50px'
   }}>
        <Paper sx={{
            border:'1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
             margin: '0 auto',
             minHeight: '500px',
             backgroundColor: 'white',
             position: 'relative'
        }}>
             <Box>
                {(!questions || questions.length === 0) ? (
                  <Paper
                    sx={{
                      p: 4,
                      textAlign: 'center',
                      bgcolor: 'white',
                      border: '2px dashed',
                      borderColor: 'grey.300'
                    }}
                  >
                    <Typography color="text.secondary">
                      No blocks added yet. Add your first question block to get started.
                    </Typography>
                  </Paper>
                ) : (
                  <Box>
                    {questions.map((block, index) => (
                      <MainBlock 
                        key = {block.id}
                        block = {block}
                        index = {index}
                        totalBlocks={ questions.length} />
                    ))}
                  </Box>
                )}
              </Box>
            
            <Box
                sx = {{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginTop:5,
                  '& > *': {
                    m: 1,
                  },
                }}
              >
                <ButtonGroup size="small" variant="outlined">
                  <Tooltip title="Single-Line Text" placement='bottom'>
                    <Button onClick={() => handleQuestionAdd("text")}>
                      <TextFields/>
                    </Button>
                  </Tooltip>
                  <Tooltip title="Multi-Line Text" placement='bottom'>
                    <Button onClick={() => addQuestion('textarea')}>
                      <Notes/>
                    </Button>
                  </Tooltip>
                  <Tooltip title="Radio Group" placement='bottom'>
                    <Button onClick={() => addQuestion('single_choice')}>
                      <RadioButtonChecked/>
                    </Button>
                  </Tooltip>
                  <Tooltip title="Checkbox" placement='bottom'>
                    <Button onClick={() => addQuestion('multiple_choice')}>
                      <CheckBox/>
                    </Button>
                  </Tooltip>
                  <Tooltip title="Dropdown" placement='bottom'>
                    <Button onClick={() => addQuestion('dropdown')}>
                      <ArrowDropDownCircle/>
                    </Button>
                  </Tooltip>
                  <Tooltip title="Ratings" placement='bottom'>
                    <Button onClick={() => addQuestion('rating')}>
                      <Star/>
                    </Button>
                  </Tooltip>
                    {/* <Tooltip title="Yes/No" placement='bottom'>
                    <Button onClick={() => addQuestion('file_upload')}>
                      <UploadFile/>
                    </Button>
                  </Tooltip>*/}
                </ButtonGroup>


             </Box>
        </Paper>
   </Box>
  )
}

export default EcxSurveyCanvas